<template>
  <div class="clinic-service-card">
    <b-row>
      <b-col cols="12" lg="4" xl="2" class="clinic-logo">
        <div class="d-block">
          <div  class="clinic-logo-box">
            <b-skeleton class="skeleton-img"></b-skeleton>
          </div>
            <b-skeleton class="rating-info"> </b-skeleton>
        </div>
      </b-col>

      <b-col cols="12" lg="5" xl="8">
        <div class="clinic-info">
          <b-skeleton class="clinic-name"></b-skeleton>
          <b-skeleton class="clinic-address"></b-skeleton>
          <b-skeleton class="clinic-distance"></b-skeleton>
          <b-skeleton class="available-hours-label"></b-skeleton>
          <div class="available-hours">
          <b-skeleton height="100%" width="5%"></b-skeleton>
          <b-skeleton height="100%" width="15%"></b-skeleton>
          <b-skeleton height="100%" width="15%"></b-skeleton>
          <b-skeleton height="100%" width="15%"></b-skeleton>
          <b-skeleton height="100%" width="15%"></b-skeleton>
          <b-skeleton height="100%" width="15%"></b-skeleton>
          <b-skeleton height="100%" width="15%"></b-skeleton>
          <b-skeleton height="100%" width="5%"></b-skeleton>

          </div>
        </div>
      </b-col>
      
      <b-col cols="12" lg="3" xl="2">
          <b-skeleton class="service-name"></b-skeleton>
          <b-skeleton class="service-price"></b-skeleton>
          <b-skeleton class="payment-info-label"></b-skeleton>
          <b-skeleton class="schedule-button"></b-skeleton>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import ServiceClinicCardSkeleton from "@/components/ClinicsResult/ServiceClinicCardSkeleton/ServiceClinicCardSkeleton";
export default ServiceClinicCardSkeleton;
</script>

<style lang="scss" scoped>
@import "ServiceClinicCardSkeleton.scss";
@import url("https://fonts.googleapis.com/css2?family=Montserrat:wght@600;700&display=swap");
</style>
